import { render, staticRenderFns } from "./LogworkEditor.vue?vue&type=template&id=5326f8d6&scoped=true&"
import script from "./LogworkEditor.vue?vue&type=script&lang=ts&"
export * from "./LogworkEditor.vue?vue&type=script&lang=ts&"
import style0 from "./LogworkEditor.vue?vue&type=style&index=0&id=5326f8d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5326f8d6",
  null
  
)

export default component.exports